import { render, staticRenderFns } from "./CategoriasAlarma.vue?vue&type=template&id=54c6ccf4&scoped=true"
import script from "./CategoriasAlarma.vue?vue&type=script&lang=js"
export * from "./CategoriasAlarma.vue?vue&type=script&lang=js"
import style0 from "./CategoriasAlarma.vue?vue&type=style&index=0&id=54c6ccf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c6ccf4",
  null
  
)

export default component.exports